import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'cep' })
export class CepPipe implements PipeTransform {

    public transform(value: any): any {
        if (value === null || value === undefined || value === '') {
            return '';
        }

        const cep = value.toString();

        const first = cep.slice(0, cep.length - 3);
        const last = cep.substr(cep.length - 3);

        return `${first}-${last}`;
    }
}
